export const moduleNamespace = 'appAmCostTable';
export const routeNamespace = '/cost-tables';
